export default "__VITE_ASSET__l65NMgLE__"